import React, { useContext, useEffect } from "react";
import PagoForm from "./PagoForm";
import TablaPagos from "./TablaPagos";
import ListaPagos from "../pagos/ListaPagos";
import CancelPagoForm from "./CancelPagoForm";
import useProyecto from "../../hooks/useProyecto";
import { PagosContext } from "../../context/PagosContext";
import { ModalContext } from "../../context/ModalContext";
import { CapacitorContext } from "../../context/CapacitorContext";
import EmptyState from "../common/EmptyState";


const Pagos = ({ idProyecto, idContrato }) => {
  const { pagos, editPago, clearPago, getPagosContrato, createPagoContrato } =
    useContext(PagosContext);
  const { clearModal, modalComponent } = useContext(ModalContext);
  const { platform } = useContext(CapacitorContext);
  const { permiso } = useProyecto();

  useEffect(() => {
    fetchPagos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idContrato]);

  function fetchPagos() {
    getPagosContrato(idProyecto, idContrato);
  }

  function handleCancel () {
      clearModal();
      clearPago();
  }

  function handleCallback() {
    clearModal();
    fetchPagos();
  }

  function handleCreatePago() {
    createPagoContrato();
    modalComponent(
      "Agregar Pago",
      <PagoForm
        idProyecto={idProyecto}
        idContrato={idContrato}
        handleCancel={handleCancel}
        handleCallback={handleCallback}
      />
    );
  }

  function handleEditPago(pago) {
    editPago(pago);
    const title = isNaN(parseInt(pago.idPago)) ? "Agregar" : "Editar";
    modalComponent(
      `${title} Pago`,
      <PagoForm
        idProyecto={idProyecto}
        idContrato={idContrato}
        handleCancel={handleCancel}
        handleCallback={handleCallback}
      />
    );
  }

  function handleCancelPago(pago) {
    editPago(pago);
    modalComponent(
      "Cancelar Pago",
      <CancelPagoForm
        idProyecto={idProyecto}
        idContrato={idContrato}
        handleCancel={handleCancel}
        handleCallback={fetchPagos}
      />
    );
  }

  function renderBoton() {
    if (["admin", "obras", "finanzas"].includes(permiso)) {
      return (
        <button className="btn btn-sm btn-primary" onClick={handleCreatePago}>
          <i className="fa fa-plus"></i>
        </button>
      );
    }
  }

  function renderPagos() {
    if (Array.isArray(pagos) && pagos.length === 0) {
      return (
        <EmptyState
          icon="fa fa-money-bill-wave"
          message="No hay pagos registrados para este contrato."
        />
      );
    }
    if (platform === "web") {
      return (
        <TablaPagos
          pagos={pagos}
          permiso={permiso}
          idProyecto={idProyecto}
          idContrato={idContrato}
          editPago={handleEditPago}
          cancelPago={handleCancelPago}
        />
      );
    }
    return <ListaPagos pagos={pagos} handleEdit={handleEditPago} />;
  }

  return (
    <div className="card shadow p-3">
      <div className="row align-items-center mb-2">
        <div className="col">
          <h3 className="h5 mb-0">Pagos</h3>
        </div>
        <div className="col text-end">{renderBoton()}</div>
      </div>
      {renderPagos()}
    </div>
  );
};

export default Pagos;
